import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  ChartType,
  type ChartClickEventArgs,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo, useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.RadarChart.RadarChartMainDemo';

export function RadarChartMainSample() {
  const t = useT();
  const [lastClick, setLastClick] = useState<ChartClickEventArgs | null>(null);
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'opportunityratingcode',
        aggregateColumn: 'opportunityid',
        aggregate: QueryAggregate.Count,
        seriesColumn: 'purchaseprocess',
      }),
    [],
  );
  return (
    <>
      <DataverseChart
        dataSource={source}
        type={ChartType.Radar}
        title={t(`${STRINGS_BASE}.chart-title`)}
        onElementClick={setLastClick}
      />
      {lastClick && (
        <p style={{ marginTop: '12px' }}>
          <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong>{' '}
          {lastClick.datasetLabel} — {lastClick.label} — {lastClick.value}
        </p>
      )}
    </>
  );
}
